import type { ScopedThreadRef } from "@afar-research/contracts";

import type { DraftId } from "~/composerDraftStore";
import { createWorkspaceSurfaceContext } from "~/workspaceSurfaceContext";

export interface DiffWorkspaceSurfaceContextValue {
  readonly threadRef: ScopedThreadRef;
  readonly composerDraftTarget: ScopedThreadRef | DraftId;
}

export const diffWorkspaceSurfaceContext =
  createWorkspaceSurfaceContext<DiffWorkspaceSurfaceContextValue>();

export const DiffWorkspaceSurfaceProvider = diffWorkspaceSurfaceContext.Provider;
